import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=1e050a61&"
import script from "./courseDetails.vue?vue&type=script&lang=js&"
export * from "./courseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports